import { useOpMutation } from '../useOpMutation';

export const useUpdateIdentity = () =>
  useOpMutation({
    apiEndpointName: 'updateIdentity',
  });
